module.exports = __webpack_public_path__ + "img/seat.776217eb.svg";